const faqSection = {
  init() {
    document.addEventListener('DOMContentLoaded', () => {
      const faqLinks = document.querySelectorAll('.js-faq__nav-link');
      const faqDetails = document.querySelectorAll('.faq_detail');

      faqLinks.forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          this.handleClick(link);
        });
      });

      faqDetails.forEach((detail) => {
        detail.addEventListener('click', (event) => {
          // Close other open details
          faqDetails.forEach((otherDetail) => {
            if (otherDetail !== detail) {
              otherDetail.removeAttribute('open');
            }
          });
        });
      });
    });
  },

  handleClick(link) {
    const targetId = link.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      const compensateGap = window.innerWidth < 768 ? 126 : 128; // Match the compensateGap on .content-for-layout on theme.liquid plus 40px padding top
      window.scrollTo({
        top: targetElement.offsetTop - compensateGap,
        behavior: 'smooth',
      });
    }
  },
};

faqSection.init();
